import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import api from "../../services/api";

const GoogleBook = () => {
    const location = useLocation();
    const book = location.state?.book;
    const navigate = useNavigate();
    const [adding, setAdding] = useState(false);
    const [error, setError] = useState(null);

    if (!book) {
        return <div className="text-warm-400 text-center py-24">Book not found.</div>;
    }

    const info = book.volumeInfo;

    const handleAddBook = async () => {
        setAdding(true);
        setError(null);
        try {
            const response = await api.get(`/addGoogleBook/${book.id}`);
            navigate('/book/' + response.data.id);
        } catch (err) {
            setError(err.response?.data?.error ?? 'Failed to add book. Please try again.');
            setAdding(false);
        }
    };

    return (
        <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl border border-warm-200 shadow-sm p-8 mb-6">
                <div className="flex gap-8">
                    {info.imageLinks?.thumbnail && (
                        <div className="flex-shrink-0 w-36">
                            <img
                                src={info.imageLinks.thumbnail}
                                alt={info.title}
                                className="w-full rounded-xl shadow-md object-cover"
                            />
                        </div>
                    )}
                    <div className="flex-grow min-w-0">
                        <h1 className="font-serif text-3xl font-bold text-warm-800 leading-tight mb-2">
                            {info.title}
                        </h1>
                        {info.authors && (
                            <p className="text-warm-500 font-medium">{info.authors.join(', ')}</p>
                        )}
                        {info.publishedDate && (
                            <p className="text-warm-300 text-sm mt-1">{info.publishedDate}</p>
                        )}
                        {info.categories?.length > 0 && (
                            <div className="flex flex-wrap gap-2 mt-4">
                                {info.categories.map((cat, i) => (
                                    <span key={i} className="bg-warm-100 text-warm-600 text-xs px-3 py-1 rounded-full">
                                        {cat}
                                    </span>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {info.description && (
                <div className="bg-white rounded-2xl border border-warm-200 shadow-sm p-8 mb-6">
                    <h2 className="font-serif text-lg font-semibold text-warm-800 mb-3">About this book</h2>
                    <p
                        className="text-warm-600 leading-relaxed text-sm"
                        dangerouslySetInnerHTML={{ __html: info.description }}
                    />
                </div>
            )}

            {error && (
                <div className="mb-4 bg-red-50 border border-red-200 text-red-600 text-sm rounded-lg px-4 py-3">
                    {error}
                </div>
            )}

            <button
                onClick={handleAddBook}
                disabled={adding}
                className="bg-warm-600 hover:bg-warm-700 disabled:opacity-60 text-white font-semibold px-6 py-3 rounded-lg transition-colors"
            >
                {adding ? 'Adding…' : 'Add to Library'}
            </button>
        </div>
    );
};

export default GoogleBook;
